export default function ingredientsModule() {
  const nav = jQuery('.map-nav');
  if (!nav) return;
  let activeMap;
  const buttons = nav.find('button');
  const maps = jQuery('.map-site');

  function setActiveMap(map) {
    activeMap = map;
    buttons.each((i, elem) => {
      if (elem.classList.contains(map)) elem.classList.add('active');
      else elem.classList.remove('active');
    });
    maps.each((i, elem) => {
      if (elem.classList.contains(map)) elem.classList.add('active');
      else elem.classList.remove('active');
    });
  }
  setActiveMap('map-site-1');

  buttons.click(e => {
    const elem = jQuery(e.target);
    const button = elem.is('button') ? elem : elem.parent('button');
    const map = button[0].classList.item(0);
    if (map === activeMap) return;
    setActiveMap(map);
  })
}



// WEBPACK FOOTER //
// ./scripts/modules/map-site.js